import { Component } from '@angular/core';
import { FieldArrayType } from '@ngx-formly/core';
import { Language, Translation } from 'src/models/models';
import { LanguageService } from 'src/services/language.service';
import { TranslationService } from 'src/services/translation.service';
import { faTrash} from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div class="my-3">
      <legend class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" *ngIf="props.label">{{ props.label }}</legend>
      <p *ngIf="props.description">{{ props.description }}</p>

      <div *ngFor="let field of field.fieldGroup; let i = index" class="mb-2">

      <div class="flex flex-wrap">
        <formly-field
          class="w-full sm:w-11/12"
          [field]="field">
        </formly-field>

        <div class="w-full sm:w-1/12 text-center pt-2 px-2">
          <button
            class="text-red-500"
            type="button"
            (click)="removeTranslation(i)">
            <fa-icon [icon]="faTrash"></fa-icon>
          </button>
        </div>
      </div>

      </div>
      <div style="margin:30px 0;">
        <button
          class="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
          type="button"
          (click)="add()"
          [disabled]="!canAddMore()">
          Add translation
        </button>
      </div>
    </div>
  `,
})
export class RepeatTypeComponent extends FieldArrayType {
  faTrash = faTrash;
  constructor(
    private translationService: TranslationService,
    private languageService: LanguageService
  ) {
    super();

    this.languageService.getAll().subscribe((res) => {
      this.languages = res;
    });
  }
  languages: Language[] = [];

  removeTranslation(i: number) {
    this.translationService
      .delete(this.field.model[i].id)
      .subscribe(() => {
        this.remove(i);
      });
  }

  public duplicates() {
    //check if there are mulitple items with the same languageId
    return this.model?.filter(
      (item: Translation, index: number, self: Translation[]) => {
        if (item != undefined)
          self.findIndex((t) => t.languageId === item.languageId) !== index;
      }
    );
  }

  canAddMore() {
    if(this.model == undefined) return true;
    return (
      this.duplicates().length == 0 &&
      this.model?.length < this.languages.length
    );
  }
}
